import {
  tabCloser, tabTemplate, categoryTab, tabIcons,
} from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeTasks } from '../actions';
import TasksActions from '../components/TasksActions';
import TasksPanel from '../components/TasksPanel';

export default {
  ...tabTemplate('tasks', TasksPanel, matchSingleUrl(['tasks']), TasksActions),
  ...tabCloser('closeTasksTab', closeTasks),
  ...tabIcons('tasks'),
  access: ({ tasks }) => tasks.read,
  componentState: ({ url }) => categoryTab(url, 'all'),
  order: 500,
};
